module.exports = __webpack_public_path__ + "static/media/hero-house.4ba05dba.png";